import React from "react";
import ajaoRoom from "../../assets/ajao-estate-deluxe-room.jpg";
import area1 from "../../assets/Area1-executive-suit.png";
import guzapeMini from "../../assets/area-11-luxury-room22.jpg";
import area11 from "../../assets/area-11-standard-room.jpg";
import executiveStandard from '../../assets/Executive-Standard.jpg'
import ResidencyDeluxe from '../../assets/Residency-Deluxe-02.jpg'
import MiniSuit from '../../assets/Mini-Suit-02.jpg'
import ResidencyExecutivePlus from '../../assets/Residency-Executive-Plus.jpg'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import AOS from "aos";
import "aos/dist/aos.css";
import "./HotelRoom.css";

const HotelRooms = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 1024 },
          items: 4
        },
        desktop: {
          breakpoint: { max: 1024, min: 800 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 800, min: 500 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 500, min: 0 },
          items: 1
        }
      };

  return (
    <div className=''>
      <div className='container mt-5'>
        <div className='rest__headStyle'>
          <div
            className='text-hero-bold'
            style={{ fontSize: "1.2em", fontWeight: "600" }}
          >
            Residency Rooms
            <hr />
          </div>
          <div className='text-hero-regular'>
            Residency Rooms are designed for luxury and comfort, with the state
            of art funitures that suites your class and test.
          </div>
        </div>
        <div className=' row '>
        <Carousel
//   swipeable={true}
//   draggable={true}
//   showDots={true}
  responsive={responsive}
//   ssr={true} // means to render carousel on server-side.
//   infinite={true}
//   autoPlay={responsive.deviceType !== "mobile" ? true : false}
//   autoPlaySpeed={100}
//   keyBoardControl={true}
//   customTransition="all .5"
//   transitionDuration={5000}
//   containerClass="carousel-container"
//   removeArrowOnDeviceType={["tablet", "mobile"]}
//   deviceType={responsive.deviceType}
//   dotListClass="custom-dot-list-style"
//   itemClass="carousel-item-padding-40-px"
>
          <div className='col-md-3 shadow' style={{ width: "100%" }} data-aos="slide-up" data-aos-offset="200">
            <div className='card mt-3 ' style={{ height: "87%", }}>
              <img
                src={ajaoRoom}
                className='card-img-top2 hotelRoomCard'
                alt='...'
              />
              <div class='card-body'>
                <h5 class='card-title'>Residency Deluxe </h5>
                <p class='card-text'>
                  &#8358; 32,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-3 shadow' style={{ width: "100%" }} data-aos="slide-down" data-aos-offset="150">
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={area1} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Residency Executive Suite</h5>
                <p class='card-text'>
                  &#8358;30,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>

                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-3 shadow' style={{ width: "100%" }} data-aos="slide-up" data-aos-offset="200">
            <div class='card mt-3 ' style={{ height: "87%" }}>
              <img
                src={guzapeMini}
                class='card-img-top2 hotelRoomCard'
                alt='...'
              />
              <div class='card-body'>
                <h5 class='card-title'>Executive luxury</h5>
                <p class='card-text'>
                  &#8358;33,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>{" "}
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>
          <div className='col-md-3 shadow' style={{ width: "100%" }} data-aos="slide-down" data-aos-offset="150">
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={area11} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Standard room</h5>
                <p class='card-text'>
                  &#8358;28,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3 shadow' style={{ width: "100%" }}>
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={executiveStandard} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Executive Standard</h5>
                <p class='card-text'>
                  &#8358;30,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3 shadow' style={{ width: "100%" }}>
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={ResidencyDeluxe} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Residency Deluxe</h5>
                <p class='card-text'>
                  &#8358;27,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3 shadow' style={{ width: "100%" }}>
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={MiniSuit} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Mini-Suit</h5>
                <p class='card-text'>
                  &#8358;27,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3 shadow' style={{ width: "100%" }}>
            <div class='card  mt-3 ' style={{ height: "87%" }}>
              <img src={ResidencyExecutivePlus} class='card-img-top2 hotelRoomCard' alt='...' />
              <div class='card-body'>
                <h5 class='card-title'>Residency Executive Plus</h5>
                <p class='card-text'>
                  &#8358;33,000{" "}
                  <span className='perNight' style={{ fontSize: "0.7em" }}>
                    / per night
                  </span>
                </p>
                <p class='card-text'>
                  <small class='text-muted'></small>
                </p>
              </div>
            </div>
          </div>
</Carousel>
        </div>
      </div>
    </div>
  );
};

export default HotelRooms;
